export default __webpack_public_path__ + "static/media/prev-E1A-SIDE-VIEW-1.619fedcc.png";